import StateTransitionService from "../infractions/stateTransitionService";
import PDFDocument from "../pdf/pdfDocument";
import PaymentHandlers from "../handlers/paymentHandlers";
import store from "@/store/index";

class StatesHandlers {
  static async handleLabrada(infraction) {
    return {
      subtittle: `Notificacion de Infraccion`,
      message: `Se le notifica del labrado del acta ${infraction.act.act_number}`,
      needValidation: true,
    };
    // Lógica específica para LABRADA
  }
  static async handleNotificada(infraction) {
    return {
      subtittle: `Notificación de Infraccion`,
      message: `Se le notifica del labrado del acta ${infraction.act.act_number} el dia ${formatDate()}. 
      Para acceder a sus multas dirijase a la oficina virtual y desde el inicio haga click en "Transito - Licencias y Multas" luego en "Multas" `,
      function: PDFDocument.NotificationPDF,
      needValidation: true,
    };
    // Lógica específica para NOTIFICADA
  }
  static async handleDescargo(infraction) {
    //const response = await StateTransitionService.createDischargeProcedure({infractionId: infraction.id})
    //if(!response.success) return se saca de aca porque en caso de que quisiera cancelar el descargo este ya estaria creado
    return {
      subtittle: `Notificacion de Infraccion`,
      message: `Se le notifica del descargo del acta ${infraction.act.act_number} el dia ${formatDate()}.`,
      //en caso de agregar procedure y permitir comentario function debe hacerse responsable de subir los archivos seleccionados
      procedure: {
        function: StateTransitionService.createDischargeProcedure,
        allowComment: true
      },
      needValidation: true,
    };
    // Lógica específica para DESCARGO
  }
  static async handleSentencia(infraction) {
    return {
      subtittle: `Notificacion de Infraccion`,
      message: `Se le notifica de la sentencia del acta ${infraction.act.act_number} el dia ${formatDate()}`,
      //en caso de agregar procedure y permitir comentario function debe hacerse responsable de subir los archivos seleccionados
      procedure: {
        function: StateTransitionService.createSentence,
        allowComment: true
      },
      needValidation: true,
    };
    // Lógica específica para SENTENCIA
  }
  static async handleRecurrida(infraction) {
    return {
      subtittle: `Notificacion de Infraccion`,
      message: `Se le notifica del paso a recurrida del acta ${infraction.act.act_number} el dia ${formatDate()}`,
      needValidation: true,
    };
    // Lógica específica para RECURRIDA
  }
  static async handleSentenciaFirme(infraction) {
    return {
      subtittle: `Notificacion de Infraccion`,
      message: `Se le notifica del paso a sentencia firme del acta ${infraction.act.act_number} el dia ${formatDate()}`,
      needValidation: true,
    };
    // Lógica específica para SENTENCIA FIRME
  }
  static async handlePagada(infraction) {
    const usePay = store.state.user.muniAreas ? !store.state.user.muniAreas.some(item => item.area.area_name === "MULTAS") : true
    if (usePay) {
      return {
        subtittle: `Notificacion de Infraccion`,
        message: `Se le notifica del pago del acta ${infraction.act.act_number} el dia ${formatDate()}`,
        //en caso de agregar procedure y permitir comentario function debe hacerse responsable de subir los archivos seleccionados
        procedure: {
          function: PaymentHandlers.handleInfractionPaymentSIRO,
          allowComment: false
        },
        needValidation: true,
      };
    } else {
      return {
        subtittle: `Notificacion de Infraccion`,
        message: `Se le notifica del pago del acta ${infraction.act.act_number} el dia ${formatDate()}`,
        function: PDFDocument.NotificationPDF,
      };
    }
    // Lógica específica para PAGADA
  }
  static async handleCancelada(infraction) {
    return {
      subtittle: `Notificacion de Infraccion`,
      message: `Se le notifica de la desestimacion del acta ${infraction.act.act_number} el dia ${formatDate()}`,
      needValidation: false,
    };
    // Lógica específica para DESESTIMADA
  }
  static async handleArchivada(infraction) {
    return {
      subtittle: `Notificacion de Infraccion`,
      message: `Se le notifica de el archivado del acta ${infraction.act.act_number} el dia ${formatDate()}`,
      needValidation: false,
    };
    // Lógica específica para ARCHIVADA
  }
  static async handleAnulada(infraction) {
    return {
      subtittle: `Notificacion de Infraccion`,
      message: `Se le notifica de la anulacion del acta ${infraction.act.act_number} el dia ${formatDate()}`,
      needValidation: false,
    };
    // Lógica específica para ANULADA
  }
}

const formatDate = () => {
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  };

  const date = new Date();

  // Formatear la fecha
  const formattedDate = date.toLocaleDateString("es-ES", options);

  // Formatear la hora
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const formattedTime = `${hours}:${minutes}`;

  // Combinar fecha y hora
  return `${formattedDate} ${formattedTime}`;
};

export default StatesHandlers;
